import React, { useEffect, useRef, useState } from "react";
import BgSquare from "../../animation/BgSquare";
import { Link } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import burgerImg from "../../../media/images/filters/burger.webp";
import dessertImg from "../../../media/images/filters/dessert.webp";

const BannerMenu = () => {
  const [bannerIndex, setbannerIndex] = useState(0);

  const cardScrollRef = useRef();

  const bannerData = [
    {
      name: "50% off on selected items",
      desc: "Apply on selected items.",
      img: burgerImg,
      badge: "NEW",
      badgeColor: "",
      backgroundColor: "var(--color-primary)",
      link: "",
    },
    {
      name: "Order 5 or more, save $100 extra",
      desc: "No questions asked, any 5 orders will be eligible.",
      img: dessertImg,
      badge: "Saver Deal",
      badgeColor: "",
      backgroundColor: "var(--color-secondary)",
      link: "",
    },
  ];

  function prevBanner() {
    if (bannerIndex === 0) {
      setbannerIndex(bannerData.length - 1);
    } else {
      setbannerIndex((prevProps) => prevProps - 1);
    }
  }

  function nextBanner() {
    if (bannerIndex === bannerData.length - 1) {
      setbannerIndex(0);
    } else {
      setbannerIndex((prevProps) => prevProps + 1);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      nextBanner();
    }, 5000);
    return () => {
      clearInterval(interval);
    };
  }, [bannerIndex]);

  useEffect(() => {
    const slider = cardScrollRef.current;
    let isDown = false;
    let startX;
    let prevX; // Variable to store the previous mouse position

    const mouseDown = (e) => {
      isDown = true;
      slider.classList.add("grab-active");

      prevX = e.pageX; // Store the initial mouse position
    };

    const mouseLeave = () => {
      isDown = false;
      slider.classList.remove("grab-active");
    };

    const mouseUp = () => {
      isDown = false;
      slider.classList.remove("grab-active");
    };

    const mouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();

      // Check if the current mouse position is to the left or right of the previous position
      const direction = e.pageX > prevX ? "right" : "left";
      prevX = e.pageX; // Update the previous mouse position

      // Now you can use the direction variable to determine the direction of movement
      if (direction === "right") {
        prevBanner();
      } else {
        nextBanner();
      }
    };

    const touchStart = (e) => {
      const touch = e.touches[0];
      startX = touch.pageX;
      prevX = startX;
    };

    const touchMove = (e) => {
      if (!startX) return;

      const touch = e.touches[0];
      const currentX = touch.pageX;

      if (startX - currentX > 50) {
        // Swipe right
        nextBanner();
        startX = null;
      } else if (currentX - startX > 50) {
        // Swipe left
        prevBanner();
        startX = null;
      }
    };

    slider.addEventListener("mousedown", mouseDown);
    slider.addEventListener("mouseleave", mouseLeave);
    slider.addEventListener("mouseup", mouseUp);
    slider.addEventListener("mousemove", mouseMove);
    slider.addEventListener("touchstart", touchStart);
    slider.addEventListener("touchmove", touchMove);

    return () => {
      slider.removeEventListener("mousedown", mouseDown);
      slider.removeEventListener("mouseleave", mouseLeave);
      slider.removeEventListener("mouseup", mouseUp);
      slider.removeEventListener("mousemove", mouseMove);
      slider.removeEventListener("touchstart", touchStart);
      slider.removeEventListener("touchmove", touchMove);
    };
  }, [bannerIndex]);

  return (
    <div className="banner-menu">
      <div className="wrapper" ref={cardScrollRef}>
        <BgSquare />
        {bannerData.map((item, i) => (
          <div
            key={item.name}
            className={`banner ${bannerIndex === i ? "banner-visible" : ""}`}
            style={{ color: item.color }}
          >
            <div className="bg-color" style={{ backgroundColor: item.backgroundColor }} />
            <div className="details">
              {item.badge && (
                <div className="badge" style={{ backgroundColor: item.badgeColor }}>
                  <h3 className="badge-text">{item.badge}</h3>
                </div>
              )}
              <h1 className="banner-name">{item.name}</h1>
              <p className="banner-desc">{item.desc}</p>
            </div>
            {/* <img src={item.img} alt="emoji" /> */}
          </div>
        ))}
      </div>

      <div className="actions">
        <div className="indicators">
          {bannerData.map((item, i) => (
            <div key={item.name} className={`indicator ${bannerIndex === i ? "active" : ""}`} />
          ))}
        </div>
        <div className="toggle-icons">
          <div className="icon hd-mb" onClick={prevBanner}>
            <ChevronLeftIcon />
          </div>
          <div className="icon hd-mb" onClick={nextBanner}>
            <ChevronRightIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerMenu;
